import { render, staticRenderFns } from "./BaseCategorySelector.vue?vue&type=template&id=46aa9f8c"
import script from "./BaseCategorySelector.vue?vue&type=script&lang=js"
export * from "./BaseCategorySelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports